import { createRoutine } from 'redux-saga-routines';

export const getRefForManualInputRoutine = createRoutine('GET_REF_FOR_MANUAL_INPUT');
export const resetRefSurveyDataRoutine = createRoutine('RESET_REF_SURVEY_DATA');
